import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const FinancingPage = lazy(() => import('../pages/financing/page'));
const InsurancePage = lazy(() => import('../pages/insurance/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/societe',
    element: <CompanyPage />
  },
  {
    path: '/financement',
    element: <FinancingPage />
  },
  {
    path: '/assurance',
    element: <InsurancePage />
  },
  {
    path: '/partenaires',
    element: <PartnersPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/mentions-legales',
    element: <LegalPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
